<style scoped lang='less'>
	.main-content {
		width: 100%;
		min-height: 100%;
		padding: 70px 0 100px 180px;
	}
	
	.min-padding {
		padding: 70px 0 20px 180px;
	}
	
	.main-alone {
		width: 100%;
		min-height: 100%;
	}
	
	#loading {
		background: rgba(255, 255, 255, .6);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 100;
		width: 100%;
		height: 100%;
		transform: translate(0, -100%);
		z-index: 999;
		//transition: transform .1s;
	}
	
	#loading.active {
		transform: translate(0, 0);
	}
	
	#loading-animation {
		width: 40px;
		height: 40px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, 50%);
	}
	
	#loading-animation::before,
	#loading-animation::after {
		content: "";
		display: block;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: #333;
		opacity: 0.6;
		position: absolute;
		top: 0;
		left: 0;
		animation: loading-bounce 2s infinite ease-in-out;
	}
	
	#loading-animation::after {
		-webkit-animation-delay: -1s;
		-o-animation-delay: -1s;
		animation-delay: -1s;
	}
	
	@keyframes loading-bounce {
		0%,
		100% {
			transform: scale(0.0)
		}
		50% {
			transform: scale(1.0)
		}
	}
	
	.my-load {
		width: 100%;
		height: 100%;
		position: absolute;
		background: #eee;
		top: 0px;
	}
</style>
<template>
	<div id="app" class="clear" ref="app" v-loading="routeLoading">
		<common-head v-if="appShow"></common-head>
		<common-nav v-if="appShow"></common-nav>
		<div :class="{'main-content':appShow,'main-alone':!appShow, 'min-padding':paddingBottom }">
			<!-- keep-live -->
			<router-view/>
		</div>
		<div></div>
		<div id="loading" :class="{'active':loadingIsShow}">
			<div id="loading-animation"></div>
		</div>
	</div>
</template>

<script>
	import CommonHead from "./pages/CommonHead/CommonHead"
	import CommonNav from "./pages/CommonNav/CommonNav"
	import eventBus from '../src/eventBus/eventBus.js'
	import { axiosGet, axiosPost } from './axios/axios.js'
	export default {
		name: 'App',
		components: {
			CommonHead,
			CommonNav
		},
		data: function() {
			return {
				loadingIsShow: false, //控制加载动画
				alonePage: [
				'/account',
				'/account/login', 
				'/account/register', 
				'/account/retrieve', 
				'/', 
				'/advertiser', 
				'/publish',
				'/sdk',
				'/about',
				'/termsservice',
				'/sdkdoc/androidsdkup',
				'/sdkdoc/iossdkup',
				'/sdkdoc/kyysdkup',
				'/termsprivacy',
				],
				appShow: false,
				paddingBottom: false, //兼容文档对接页面
				routeLoading: false
			}
		},
		methods: {

		},
		created() {
			//监听loading事件 切换加载动画
			eventBus.$on("loading", (val) => {
				this.loadingIsShow = val.toggle;
			})
			eventBus.$on("togglePaddingBottom", (val) => {
				this.paddingBottom = val.toggle;
			})
		},
		watch: {
			// 如果路由有变化，会执行该方法
			$route() {
				let realPath = this.$route.path;
				let setedPath = (realPath.charAt(realPath.length - 1) == '/' ? realPath.substring(0, realPath.length - 1) : realPath);
				if(realPath == '/'){
					this.appShow = false;
				}else{
					this.appShow = (this.alonePage.indexOf(setedPath) == -1);
				}
			}
		},
		destroyed() {
			//销毁sid 与 token
			localStorage.removeItem('sid');
			localStorage.removeItem('token')
		},

	}
</script>


// WEBPACK FOOTER //
// src/App.vue